import {TombOfAkhenatenReelSymbol} from "./TombOfAkhenatenReelSymbol";
import {
    ISymbolSizeConfig,
    ISymbolStateConfig,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {TweenLite} from "gsap";

export class TOALowSymbol extends TombOfAkhenatenReelSymbol {

    constructor(symName: string, reelId: number, state?: ISymbolStateConfig, size?: ISymbolSizeConfig) {
        super(symName, reelId, state, size);
    }

    private static lowSymAnchorPositioning(rowCount: number): number[] {
        let anchorPos: number[] = [];

        switch (rowCount) {
            case 3:
                anchorPos = [0.5, 0.5];
                break;

            case 4:
                anchorPos = [0.5, 0.6];
                break;

            case 5:
                anchorPos = [0.5, 0.725];
                break;
        }

        return anchorPos;
    }

    private static lowSymScaling(rowCount: number): number {
        return rowCount === 5 ? 0.8 : 1;
    }

    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();

        //below code is for arranging bg & symbol image on spin stop
        let symAnchorPosition = TOALowSymbol.lowSymAnchorPositioning(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN),
            symScaleValue = TOALowSymbol.lowSymScaling(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN);

        /*this._background!.anchor.set(symAnchorPosition[0], symAnchorPosition[1]);
        this._symImage!.anchor.set(symAnchorPosition[0], symAnchorPosition[1]);
        this._symImage!.scale.set(symScaleValue);*/

        (<PIXI.Sprite[]>this.children).forEach((sprite: PIXI.Sprite) => {
            if(sprite.name.indexOf("_bg") > -1){
                sprite.anchor.set(symAnchorPosition[0], symAnchorPosition[1]);
            }else if(sprite.name.indexOf("_symImage") > -1){
                sprite.anchor.set(symAnchorPosition[0], symAnchorPosition[1]);
                sprite.scale.set(symScaleValue);
            }
        });

    }

    protected addNewStateAnimation(timeline: gsap.TimelineLite, newState: SymbolStateTransition, stateAnimation: TimelineSprite, delay: number) {
        if (newState.state.keyword === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.win.keyword) {
            let symAnchorPosition = TOALowSymbol.lowSymAnchorPositioning(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN),
                symScaleValue = TOALowSymbol.lowSymScaling(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN);
            stateAnimation.scale.set(symScaleValue);
            stateAnimation.pivot.set(0, TombOfAkhenatenGameConfig.instance.SYMBOL_HEIGHT * (symAnchorPosition[1] - 0.5));
            timeline.add(new SpineTween((stateAnimation as any), 0, "win", 0), delay);
            timeline.add(TweenLite.to(stateAnimation, 0.001, {alpha: 1}), delay);
            return;
        }
        if (newState.state.keyword === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.idle?.keyword) {
            const symName: string = this.symName;
            const spine = stateAnimation as any;
            spine.skeleton.setSkin(null);
            spine.skeleton.setSkinByName(TombOfAkhenatenGameConfig.instance.LOW_SYM_MAP.get(symName));
            spine.skeleton.setSlotsToSetupPose();
            timeline.add(new SpineTween((stateAnimation as any), 0, "idle", 0), delay);
            timeline.add(TweenLite.to(stateAnimation, 0.001, {alpha: 1}), delay);
            return;
        }
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);
    }
}